import { RotateUpdater } from "./RotateUpdater.js";
export async function loadRotateUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("rotate", (container) => new RotateUpdater(container), refresh);
}
